import isString from "lodash/isString";
import { logDeprecationMessage } from "@jutro/platform";
export function resolveComponentFromMap(component) {
  var componentMap = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  if (isString(component)) {
    var resolvedComponent = componentMap[component];
    return resolvedComponent || (logDeprecationMessage("Support for componentMaps with case-insensitive keys", "Adjust the keys in your componentMap to match the name of the component"), resolvedComponent = componentMap[component.toLowerCase()]), resolvedComponent;
  }
  return component;
}